import { useLang } from "@/lib/LanguageContext";

export default function Marquee() {
    const { t } = useLang();
    const items = [...t.marquee, ...t.marquee];

    return (
        <section
            data-testid="marquee"
            className="relative border-y border-hairline py-6 overflow-hidden bg-ivory-deep/40"
        >
            <div className="marquee-track flex whitespace-nowrap gap-12 w-max">
                {items.map((it, i) => (
                    <span
                        key={`${it}-${i}`}
                        className="font-serif italic text-2xl md:text-3xl text-navy/70 flex items-center gap-12"
                    >
                        {it}
                        <span className="inline-block w-2 h-2 rounded-full bg-terracotta" />
                    </span>
                ))}
            </div>
        </section>
    );
}
